export default __webpack_public_path__ + "f598a7b27918228c54903f3a07708343.png";